<div
  bp-transition
  matRipple
  class="flex items-center w-full py-3 rounded-lg cursor-pointer md:p-3 hover:bg-gray-100"
>
  <!-- Left side (images) -->
  <ng-container>
    <!-- Skeleton -->
    @if (!goal && !customGoalInfo) {
      <div class="flex-shrink-0">
        <div
          class="max-w-full mr-6 bg-gray-200 rounded-full h-13 w-13 dark:bg-gray-700 animate-pulse"
        ></div>
      </div>
    }

    <!-- Goal image -->
    @if (goal) {
      <div class="relative flex-shrink-0">
        <img
          [src]="goal?.imageSmall"
          [alt]="goal?.title"
          class="object-cover object-center mr-6 rounded-full w-13 h-13"
        />
        @if (hasStarred && goal?.starred) {
          <button
            class="absolute scale-[.65] right-[7px] bottom-[-8px] bg-white shadow-lg md:hidden"
            mat-icon-button
          >
            <mat-icon class="text-yellow-400 icon-size-5">star</mat-icon>
          </button>
        }
      </div>
    }
    <!-- / Goal image -->

    <!-- Custom goal image -->

    @if (customGoalInfo && customGoalInfo.image) {
      <div class="relative flex-shrink-0 mr-6 w-13 h-13">
        <img
          [src]="customGoalInfo.image"
          [alt]="customGoalInfo?.title"
          class="object-cover object-center w-full h-full rounded-full"
        />
        @if (customGoalInfo.hasAddButton) {
          <button
            mat-mini-fab
            color="primary"
            class="absolute transform -translate-x-1/2 -translate-y-1/2 bg-white text-primary-400 icon-size-5 top-1/2 left-1/2"
          >
            <mat-icon class="icon-size-4" color="primary">add</mat-icon>
          </button>
        }
      </div>
    }
    <!-- / Custom goal image -->
  </ng-container>
  <!-- Left side (images) -->

  <!-- Center side (ammounts in mobile + descriptions) -->
  <div class="flex flex-col">
    <!-- Skeleton -->
    @if (!goal && !customGoalInfo) {
      <div
        class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-[160px] max-w-full mb-3 animate-pulse"
      ></div>
      <div
        class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-[260px] max-w-full mb-3 animate-pulse"
      ></div>
      <div
        class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-[160px] max-w-full mb-3 animate-pulse"
      ></div>
    }
    <!-- Si ya hay una meta carga la tarjeta -->
    @if (goal || customGoalInfo) {
      <!-- Goal title + start -->
      <div bp-title-card class="flex flex-row items-center gap-2">
        {{ goal ? goal?.title : customGoalInfo?.title }}
        @if (hasStarred && goal?.starred) {
          <mat-icon class="hidden text-yellow-400 icon-size-4 md:inline">star</mat-icon>
        }
      </div>
      <!-- / Goal title + start -->
      <!-- New goal description -->
      @if (goal && !goal.haveDeposited && !goal.currentCapital) {
        <span class="inline align-text-bottom text-primary">
          Haz tu
          @if (goal?.goalCategory?.code === categoryConstants.wallet) {
            primer aporte
          } @else {
            primera inversión
          }
        </span>
      }
      <!-- / New goal description -->
      <!-- Goal without founds description -->
      @if (goal && goal.haveDeposited && !goal.currentCapital) {
        <span class="inline align-text-bottom text-secondary">
          Puedes eliminar la meta o volver a
          @if (goal?.goalCategory?.code === categoryConstants.wallet) {
            aportar
          } @else {
            invertir
          }
        </span>
      }
      <!-- / Goal without founds description -->
      <!-- Custom goal description -->
      @if (customGoalInfo) {
        <span bp-text-values-card class="inline align-text-bottom">
          {{ customGoalInfo.subtitle }}
        </span>
      }
      <!-- / Custom goal description -->
      <!-- Goal currentCapital -->
      @if (goal && goal.currentCapital) {
        <span bp-text-values-card class="inline align-text-bottom text-secondary md:hidden">
          {{
            goal?.currentCapital
              | currency
                : goal?.currency?.currencyCode
                : goal?.currency?.display
                : goal?.currency?.digitsInfo
          }}
        </span>
      }
      <!-- / Goal currentCapital -->
    }
  </div>
  <!-- / Center side (ammounts in mobile + descriptions -->

  <!-- Right side (ammounts in desktop + right arrows) -->
  <div class="ml-auto">
    <!-- Goal currentCapital -->
    @if (goal) {
      <span
        class="hidden align-text-bottom md:block"
        [ngClass]="{ 'md:block': goal && goal.currentCapital }"
      >
        {{
          goal?.currentCapital
            | currency
              : goal?.currency?.currencyCode
              : goal?.currency?.display
              : goal?.currency?.digitsInfo
        }}
      </span>
    }
    <!-- / Goal currentCapital -->

    <!-- Right arrow icon -->
    @if (customGoalInfo || (goal && !goal.haveDeposited && !goal.currentCapital)) {
      <button mat-icon-button>
        <mat-icon
          [svgIcon]="'heroicons_outline:chevron-right'"
          class="icon-size-5 text-default"
        ></mat-icon>
      </button>
    }
    <!-- / Right arrow icon -->

    <!-- Trash arrow icon -->
    @if (goal && goal.haveDeposited && !goal.currentCapital) {
      <button (click)="$event.stopPropagation(); onRemoveGoal()" mat-icon-button>
        <mat-icon [svgIcon]="'heroicons_outline:trash'" class="icon-size-5 text-default"></mat-icon>
      </button>
    }
    <!-- / Trash arrow icon -->
  </div>
  <!-- / Right side (ammounts in desktop + right arrows) -->
</div>
